import type { KeyboardEvent } from "react";

/** Astryx's TextInput doesn't trigger implicit form submission on Enter. */
export function submitOnEnter(commit: () => void) {
  return (e: KeyboardEvent) => {
    if (e.key === "Enter" && !e.nativeEvent.isComposing) {
      e.preventDefault();
      commit();
    }
  };
}
